export const ROUTES = {
  login: "/login",
  signup: "/signup",
  signupSuccess: "/signup/success",
  forgotPassword: "/forgot-password",
  setPassword: "/set-password",
  dashboard: "/dashboard",
  profile: "/profile",
  newProjectAddress: "/new-project/address",
  newProjectCrop: "/new-project/crop",
  newProjectFeatures: "/new-project/features",
  newProjectStyle: "/new-project/style",
  newProjectGenerating: "/new-project/generating",
  newProjectResult: (projectId: string) => `/projects/${projectId}`,
  newProjectEstimate: (projectId: string, estimateId: string) =>
    `/projects/${projectId}/estimates/${estimateId}`,
} as const;
